import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExpand = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2.0835 15.1035L2.0835 4.89518C2.0835 4.45768 1.8335 4.16602 1.4585 4.16602C1.0835 4.16602 0.833496 4.45768 0.833496 4.89518L0.833496 15.1035C0.833496 15.541 1.0835 15.8327 1.4585 15.8327C1.8335 15.8327 2.0835 15.541 2.0835 15.1035Z",
			fill: "#636C7B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.5835 15.1035L19.5835 4.89518C19.5835 4.45768 19.3335 4.16602 18.9585 4.16602C18.5835 4.16602 18.3335 4.45768 18.3335 4.89518L18.3335 15.1035C18.3335 15.541 18.5835 15.8327 18.9585 15.8327C19.3335 15.8327 19.5835 15.541 19.5835 15.1035Z",
			fill: "#636C7B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.6724 7.89844L16.4639 9.68997L14.6724 11.4815",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.12402 11.4805L3.33249 9.68894L5.12402 7.8974",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.4639 9.68898L11.25 9.68898",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3.33251 9.68993L8.5464 9.68993",
			stroke: "#636C7B",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgExpand;
